import { ref } from 'vue'

export const pageBlockFlag = ref(false)
